import { booleanAttribute, Component, input, OnInit, output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from "src/app/components/card/card.component";
import { FormAreaComponent } from 'src/app/components/form-area/form-area.component';
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { PaymentMethodsSelectComponent } from "src/app/components/select-by-endpoint/payment-methods-select/payment-methods-select.component";

@Component({
  selector: 'app-financial-information-card',
  standalone: true,
  imports: [
    CardComponent,
    FormAreaComponent,
    TranslateModule,
    MatSlideToggle,
    PaymentMethodsSelectComponent
],
  templateUrl: './financial-information-card.component.html'
})
export class FinancialInformationCardComponent implements OnInit {
  @ViewChild('cardComponent') cardComponent!: CardComponent;

  index = input<number>();
  totalItems = input<number>();
  control = input.required<any>();
  remove = output<void>();
  disabled = input(false, { transform: booleanAttribute });

  ngOnInit(): void {
    if (this.disabled()) {
      this.control().disable();
    }
  }

  isFormInvalid(): void {
    if (this.control().invalid && this.cardComponent) {
      this.cardComponent.isOpen.set(true);
    }
  }
}
